import { audio } from '../systems/audio/AudioSystem.js';

/**
 * The tutorial's only chrome: a Skip control parked out of the way in the
 * corner. Everything else the tutorial says is drawn in the arena itself
 * (Game._drawTutorialPrompt), because the point of the stage is to make the
 * player look at the arena.
 *
 * Skipping is a first-class exit, not a hidden escape hatch — a returning
 * player on a fresh device shouldn't have to sit through a drill to reach the
 * game, and burying the button is how a 30-second tutorial becomes the thing
 * people complain about.
 */
export class TutorialOverlay {
  constructor(root, { onSkip }) {
    this.root = root;
    this.el = document.createElement('div');
    this.el.className = 'tutorial-overlay';
    this.el.innerHTML = '<div class="tutorial-overlay-kicker">TUTORIAL</div>';

    const skip = document.createElement('button');
    skip.type = 'button';
    skip.className = 'menu-button tutorial-skip';
    skip.textContent = 'Skip';
    skip.addEventListener('click', () => { audio.playSfx('click'); onSkip(); });
    this.el.appendChild(skip);

    this.root.appendChild(this.el);
  }

  destroy() {
    this.el.remove();
  }
}
